import { useEffect } from 'react';
import { APP_DOCUMENT_TITLE_SUFFIX } from '../constants/appTitle';

/**
 * Sets the browser tab title. Pass a page-specific label, or null/undefined for app name only.
 */
export function useDocumentTitle(pageTitle: string | null | undefined): void {
  useEffect(() => {
    const trimmed = pageTitle?.trim();
    document.title = `${trimmed}`;
  }, [pageTitle]);
}
